import en from './locales/en/translation.json'
import he from './locales/he/translation.json'
import es from './locales/es/translation.json'
import tr from './locales/tr/translation.json'
import pt from './locales/pt/translation.json'
import fr from './locales/fr/translation.json'
import id from './locales/id/translation.json'
import it from './locales/it/translation.json'
import th from './locales/th/translation.json'
import zh from './locales/zh/translation.json'
import ru from './locales/ru/translation.json'
import vi from './locales/vi/translation.json'
import ja from './locales/ja/translation.json'
import ar from './locales/ar/translation.json'

export const translations = {
  en,
  he,
  es,
  pt,
  tr,
  fr,
  id,
  it,
  th,
  zh,
  vi,
  ru,
  ar,
  ja
}